import { createBrowserRouter, useRouteError } from 'react-router-dom';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFormClean } from 'store/reducers/formslice';
// ==============================|| ROUTES RENDER ||============================== //

// Component to handle chunk files loading issues
const ChunkErrorBoundary = () => {
  const routerError: any = useRouteError();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      routerError?.name === 'ChunkLoadError' ||
      routerError?.message?.includes('Failed to fetch dynamically imported module') ||
      routerError?.message?.includes('Importing a module script failed')
    ) {
      dispatch(setFormClean()); // Reset page blocker if it is enabled to don not interupt screen refresh
      setTimeout(() => window.location.reload()); // setTimeout will trigger once dispatch event is done for page blocker
    }
  }, [routerError, dispatch]);
  return <></>;
};

export const createRouterObject = () =>
  createBrowserRouter([
    {
      path: '/',
      errorElement: <ChunkErrorBoundary />,
      children: [...LoginRoutes(), ...MainRoutes()]
    }
  ]);
